export interface ISerialiser<Unserialised = unknown, Serialised = unknown> {
  serialise(data: Unserialised): Serialised;
  unserialise(data: Serialised): Unserialised;
}
